import { METAL_ROOF_CDN_PATH, METAL_ROOF_PATH } from '../../metal-roof-constants';

export type MetalRoofOtherTypesStructure = {
  key: string;
  alt: string;
  imgSrc: string;
  title: string;
  link: {
    href: string;
    title: string;
  };
};

export const METAL_ROOFT_OTHER_TYPES_LIST: MetalRoofOtherTypesStructure[] = [
  {
    key: 'metallocherepica',
    alt: 'Фото металлочерепицы',
    imgSrc: `${METAL_ROOF_CDN_PATH}/other-types/metal-roofing.jpg/metal-roofing.jpg`,
    title: 'Металлочерепица',
    link: {
      href: `${METAL_ROOF_PATH}metallocherepica/`,
      title: 'Изготовление кровли из металлочерепицы на заказ',
    },
  },
  {
    key: 'profnastil',
    alt: 'Фото кровельного профнастила',
    imgSrc: `${METAL_ROOF_CDN_PATH}/other-types/roofing-corrugated-sheet.jpg/roofing-corrugated-sheet.jpg`,
    title: 'Кровельный профнастил',
    link: {
      href: `${METAL_ROOF_PATH}profnastil/`,
      title: 'Изготовление кровли из профнастила на заказ',
    },
  },
  {
    key: 'falcevaya',
    alt: 'Фото фальцевой кровли',
    imgSrc: `${METAL_ROOF_CDN_PATH}/other-types/seam-roofing.jpg/seam-roofing.jpg`,
    title: 'Фальцевая кровля',
    link: {
      href: `${METAL_ROOF_PATH}falcevaya/`,
      title: 'Изготовление фальцевой кровли на заказ',
    },
  },
  {
    key: 'gibkaya-cherepitsa',
    alt: 'Фото гибкой черепицы',
    imgSrc: `${METAL_ROOF_CDN_PATH}/other-types/flexible-shingles.jpg/flexible-shingles.jpg`,
    title: 'Гибкая черепица',
    link: {
      href: `${METAL_ROOF_PATH}gibkaya-cherepitsa/`,
      title: 'Кровля из гибкой черепицы на заказ',
    },
  },
  {
    key: 'ondulin',
    alt: 'Фото ондулина',
    imgSrc: `${METAL_ROOF_CDN_PATH}/other-types/ondulin.jpg/ondulin.jpg`,
    title: 'Ондулин',
    link: {
      href: `${METAL_ROOF_PATH}ondulin/`,
      title: 'Изготовление кровли из ондулина на заказ',
    },
  },
];
